import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { TableBrowseBankKey } from '../../TableBrowseBankKey'
import { getBankKey } from 'src/api/modules/findoc'
import { useAppSelector } from 'src/redux/hooks'
import { financialDocsSelector } from 'src/redux/slices/financialDocsSlices'
import axios from 'axios'

type Props = {
    show: boolean
    country: string
    setShow: (value: boolean) => void
    onChoose: (data: any) => void
}

const BrowseBankKey: React.FC<Props> = ({
    show,
    setShow,
    country,
    onChoose
}) => {
    const {filterBankKey} = useAppSelector(financialDocsSelector)
    const { t } = useTranslation()

    const [fullBankKey, setFullBankKey] = useState<any[]>([])
    const [numberURL, setNumberURL] = useState<any[]>([])

    const fetchBankKey = async () => {
        await getBankKey(filterBankKey?.bank_name, filterBankKey?.bank_branch, country).then((res) => {
            setFullBankKey(res.data.data.data)
            setNumberURL(res.data.data.links)
        })
    }

    const paginateNumber = async (number: any) => {
        const bank_name = filterBankKey?.bank_name ?? ''
        const bank_branch = filterBankKey?.bank_branch ?? ''
        const res = await axios.get(
          `${number}&bank_name=${bank_name}&bank_branch=${bank_branch}&country=${country}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
              Accept: 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        setFullBankKey(res.data.data.data)
        setNumberURL(res.data.data.links)
      }

    useEffect(() => {
        fetchBankKey()
    }, []);

    useEffect(() => {
        fetchBankKey()
    }, [country, filterBankKey]);

    return <>
        <Modal
            show={show}
            onHide={() => setShow(false)}
            centered
            backdrop='static'
            keyboard={false}
            size='lg'
        >
            <Modal.Header closeButton>
                <Modal.Title>{t('Browse')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TableBrowseBankKey
                    items={fullBankKey}
                    paginate={paginateNumber}
                    numberUrls={numberURL}
                    onSelected={(item) => {
                        onChoose(item)
                    }}
                />
            </Modal.Body>
        </Modal>
    </>
}

export default BrowseBankKey